export default __webpack_public_path__ + "static/media/KFC_Loader_Gif.66979359.gif";